import React, {useEffect,useState} from 'react';
import { Container, Row, Col, Navbar, Nav, Card, Button } from 'react-bootstrap';
import { Line, Bar } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, LineElement, PointElement, Filler } from 'chart.js';
import {get_dashboard_data_api} from "../../Enums/api_constunts"
import {postMethod} from "../../Helpers/services"
import _ from "lodash"
import { useSelector } from "react-redux";

import { useNavigate, useLocation } from "react-router-dom";
// Register ChartJS components
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  LineElement,
  PointElement,
  Filler
);




// Main Dashboard Content
const Dashboard = () => {
  const userData = useSelector((state) => state.auth.user);
  
  const navigateTo = useNavigate();
  const location = useLocation();
  const [dashboard_counts, setdashboard_counts] = useState(null);
  // Bar Chart Data
  const barChartData = {
    labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun'],
    datasets: [
      {
        label: 'Revenue',
        data: [1200, 1900, 3200, 5000, 2500, 3000],
        backgroundColor: 'rgba(75, 192, 192, 0.6)',
      },
    ],
  };

  // Line Chart Data
  const lineChartData = {
    labels: ['1', '2', '3', '4', '5', '6', '7'],
    datasets: [
      {
        label: 'Active Users',
        data: [35, 50, 65, 80, 85, 100, 110],
        fill: true,
        backgroundColor: 'rgba(75, 192, 192, 0.2)',
        borderColor: 'rgba(75, 192, 192, 1)',
        tension: 0.3,
      },
    ],
  };

  const get_dashboard_data = ()=>{
  
    let post_data = {}
  
    postMethod(get_dashboard_data_api,post_data).then((res)=>{
      if(_.has(res,"result")){
        setdashboard_counts(res["result"])

      }
     
    }).catch ((error)=>{
     
  
    })
  }
  const navigate_to_page = (path)=>{
    navigateTo(path)
  }

  useEffect(()=>{
    get_dashboard_data();
  },[location]);
  return (
    <Container fluid>
      <Row>
        
        <Col md={12}>
           <Row className="mt-4 mt-10">
            {/* Cards */}
            
            {<Col sm={6} md={4} lg={3}>
              <Card>
                <Card.Body className='bg-white' >
                  <Card.Title>Total Subscribers</Card.Title>
                  <Card.Text>{_.get(dashboard_counts,"total_subscribers")}</Card.Text>
                  <Button variant="primary" onClick={()=>navigate_to_page("/subscribers")} style={{background:"#9b311c", border:"#9b311c"}}>View </Button>
                </Card.Body>
              </Card>
            </Col>}
            {
            _.get(userData, "role_id") !=5 && <Col sm={6} md={4} lg={3}>
              <Card>
                <Card.Body className='bg-white'>
                  <Card.Title>Today Followup Calls</Card.Title>
                  <Card.Text>{_.get(dashboard_counts,"today_enquiry_followups")}</Card.Text>
                  <Button variant="primary"  onClick={()=>navigate_to_page("/enquires")} style={{background:"#9b311c", border:"#9b311c"}}>View </Button>
                </Card.Body>
              </Card>
            </Col>
            }

           
            <Col sm={6} md={4} lg={3}>
              <Card>
               
                <Card.Body className='bg-white'>
                  <Card.Title>Total Customers</Card.Title>
                  <Card.Text>{_.get(dashboard_counts,"customer_count")}</Card.Text>
                  <Button variant="primary" onClick={()=>navigate_to_page("/manage_customers")} style={{background:"#9b311c", border:"#9b311c"}}>View </Button>
                </Card.Body>
              </Card>
            </Col>

            <Col sm={6} md={4} lg={3}>
              <Card>
                <Card.Body className='bg-white'>
                  <Card.Title>Total Agents</Card.Title>
                  <Card.Text>{_.get(dashboard_counts,"total_agents")}</Card.Text>
                  <Button variant="primary" onClick={()=>navigate_to_page("/manage_agents")} style={{background:"#9b311c", border:"#9b311c"}} >View </Button>
                </Card.Body>
              </Card>
            </Col>
            
          </Row>

          {/* Chart Row */}
          <Row className="no">
            <Col md={6}>
              <Card>
                <Card.Body className='bg-white'>
                  <Card.Title>Revenue Over Time</Card.Title>
                  <Bar data={barChartData} options={{ responsive: true }} />
                </Card.Body>
              </Card>
            </Col>

            <Col md={6}>
              <Card>
                <Card.Body className='bg-white'>
                  <Card.Title>Active Users Over Time</Card.Title>
                  <Line data={lineChartData} options={{ responsive: true }} />
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Col>
      </Row>
    </Container>
  );
};



export default Dashboard;
